module.exports = __webpack_public_path__ + "img/search-solid.58b10a7c.svg";